module.exports = __webpack_public_path__ + "static/media/household_door_cupboard_built_in_open_kicthen_utility.c67408b2.wav";